/* script */
export * from "!!cache-loader?{\"cacheDirectory\":\"/Users/garrett/Desktop/_Dev/Northwestern/asd-singersavvy-frontend/node_modules/.cache/cache-loader\"}!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VocalNapsHome.vue"
import __vue_script__ from "!!cache-loader?{\"cacheDirectory\":\"/Users/garrett/Desktop/_Dev/Northwestern/asd-singersavvy-frontend/node_modules/.cache/cache-loader\"}!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VocalNapsHome.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0b4dbca6\",\"hasScoped\":false,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VocalNapsHome.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/VocalNapsHome.vue
// module id = null
// module chunks = 